export const writeToClipboard = (text?: string) => {
  if (!navigator.clipboard || !text) {
    // Couldnt write to clipboard
    return '';
  }

  navigator.clipboard.writeText(text);
  return text;
};
